import PixelObject from './PixelObject'

export default class Shape extends PixelObject {
    constructor(props) {
        super(props);
    }

    getObjectProperties() {
        const base = this.getBaseProperties()
        const object = {
            type: this.type,
            rotate: this.rotate,
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height,
            fills: this.fills,
            strokes: this.strokes,
            strokeWeight: this.strokeWeight,
            randomFill: this.randomFill,
            randomStroke: this.randomStroke,
            children: this.children,
        }

        return { ...base, ...object }
    }


}